// src/pages/HomePage.js (UPDATED with all sections)
import React from 'react';
import Navbar from '../components/layout/Navbar';
import HeroSection from '../components/sections/HeroSection';
import ExpertiseSection from '../components/sections/ExpertiseSection';
import ProductFeatures from '../components/sections/ProductFeatures';
import CompanyValues from '../components/sections/CompanyValues';
import ContactSection from '../components/sections/ContactSection';
import Footer from '../components/layout/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <ProductFeatures />
        <CompanyValues />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;